import React, { useContext, useEffect } from "react";
import "../scss/styles.scss";
import { GlobalContext } from "../context/globalContext";
import { useNavigate } from "react-router-dom";

import { useIframe } from "../hooks/useIframe";

import { Hero } from "../components/_molecules/_hero/Hero";
import { HeroSub } from "../components/_molecules/_hero-sub/HeroSub";
import { CardProductClaim } from "../components/_molecules/_card-product-claim/CardProductClaim.js";
import { Banner } from "../components/_molecules/_banner/Banner";
import { SpecSheet } from "../components/_molecules/_specsheet/SpecSheet";
import { Faqs } from "../components/_molecules/_faqs/Faqs";
import { BtnSimple } from "../components/_atoms/_btn-simple/BtnSimple.js";

export const Home = () => {
  const { state } = useContext(GlobalContext);

  //TODO Turn this into a hook
  const { brand } = state;
  const content = require(`../data/${brand}-lang.es.json`);
  const homeTxt = content.home;
  document.documentElement.classList = brand;

  //For some reasing the load event is loading before GTM
  //so we create a promise to check if GTM is loaded before sending the event
  const waitForGTMLoad = () => {
    return new Promise(function (resolve, reject) {
      (function waitForFoo() {
        if (window.dataLayer[2] !== undefined) {
          return resolve(true);
        }
        setTimeout(waitForFoo, 100);
      })();
    });
  };

  useEffect(() => {
    //GTM
    waitForGTMLoad().then(function (response) {
      //   console.log(response);
      window.dataLayer.push({
        event: "sc_homepage",
      });
    });
  }, [brand]);

  let history = useNavigate();
  var iframe = useIframe();
  // console.log(iframe);
  /*const goToSearch = (e) => {
    if (iframe !== "iframe") {
      e.preventDefault();
      history.push(`${process.env.PUBLIC_URL}/search`);
    }
  };*/

  return (
    <main>
      <section>
        <Hero
          title={homeTxt.h1}
          subtitle={homeTxt.h2}
          button={homeTxt.heroButton}
          link={homeTxt.urlToCalc}
          img={`./img/${brand}/img.jpg`}
          alt={homeTxt.h1}
          aria={homeTxt.heroButton}
          type="link"
          css="hero--dark"
          buttonCSS={brand === "bmw" ? "btn-simple--1" : "btn-simple--2"}
        />

        <HeroSub css="hero-sub--dark">
          <div className="container-grid">
            <div data-col-md="4" data-col-start-md="2">
              <CardProductClaim
                title={homeTxt.leftH3}
                subtitle={homeTxt.leftH4}
                desc={homeTxt.leftDesc}
              />
            </div>
            <div data-col-md="4" data-col-start-md="8">
              <CardProductClaim
                title={homeTxt.rightH3}
                subtitle={homeTxt.rightH4}
                desc={homeTxt.rightDesc}
              />
            </div>
          </div>
        </HeroSub>
      </section>
      <section className="container-grid">
        <Banner
          title={homeTxt.bannerTitle}
          subtitle={homeTxt.bannerSubTitle}
          img={`./img/${brand}/berlina_banner.jpg`}
          alt={homeTxt.bannerSubTitle}
        />
        <p dangerouslySetInnerHTML={{ __html: homeTxt.quoteDesc }}></p>
      </section>
      <section className="container-grid">
        <div data-col-md="12">
          <SpecSheet
            title={homeTxt.specSheet1Title}
            subtitle={homeTxt.specSheet1SubTitle}
            button={homeTxt.specSheet1Button}
            type="link"
            link={homeTxt.urlToCalc}
            small={homeTxt.specSheet1Small}
            aria={homeTxt.specSheet1SubTitle}
            specs={homeTxt.specSheet1Prods}
          />
        </div>
      </section>
      <section className="container-grid">
        <Banner
          title={homeTxt.bannerTitle2}
          subtitle={homeTxt.bannerSubTitle2}
          img={`./img/${brand}/berlina.jpg`}
          alt={homeTxt.bannerSubTitle2}
        />
        <p dangerouslySetInnerHTML={{ __html: homeTxt.textImgDesc }}></p>
        <p>
          Este programa está disponible para una selección de modelos{" "}
          {brand.toUpperCase()} con más de 4 años de antigüedad.
        </p>
        <div>
          <BtnSimple
            aria=""
            type="link"
            target="_blank"
            href={homeTxt.urlToCalc}
            css="btn-simple--1"
            children={homeTxt.textImgButton}
          />
        </div>
      </section>
      <section className="container-grid">
        <Faqs title={homeTxt.faqTitle} children={homeTxt.faq} />
        <div><p>{homeTxt.legalText}</p></div>
      </section>
    </main>
  );
};
